import { message } from 'antd';
import i18n from 'i18n';

export const showInfo = (msg) => message.info(msg);
export const showError = (error) => message.error(error);

export const showGenericError = () =>
  showError(i18n.t('showGenericErrorContactSupport'));
